<style lang="scss" src='./AlertList.scss' scoped></style>
<template src="./AlertList.html"></template>

<script>
  import AlertFullDetails from '@/views/alerts/components/alertList/alertFullDetails/AlertFullDetails.vue';
  
  import {
    mapState,
    mapActions,
    mapMutations,
  } from 'vuex';

  export default {
    name: 'AlertList',
    components: {
      AlertFullDetails,
    },


    data() {
      return {
        selectedAlert: {},
        can_create_tasks: false,
        currentSort: 'last_seen',
        currentSortOrder: 'desc',
      };
    },


    computed: {
      alerts: {
        get() {
          return this.alertsStore;
        },
        set(value) {
          this.setAlerts(value)
        }
      },

      ...mapState('Alerts', {
        alertsStore: (state) => state.alerts,
        loading: (state) => state.loading,
      }),
      
      ...mapState(['course']),

      isCourseType(){
        if( (this.course.facility_type && this.course.facility_type.is_golf_course) 
        || !this.course.facility_type){
          return true;
        }else{
          return false;
        }
      },
    },


    methods: {

      selectAlert(alert) {
        if (alert) {
          this.selectedAlert = alert; 
        }
      },

      validateUserPermissions() {
        let menuPolicy = this.$store.state.menuPolicy.find((policy) => policy.vue_component == 'TaskBoard');
        this.can_create_tasks = menuPolicy.policy.can_create;
      },

      async loadData() {
        this.validateUserPermissions();
        await this.apiGetOpenedAlertByCourse();
        if (! this.G_isEmptyArr(this.alerts)) {
          this.selectedAlert = this.alerts[0];
        }

      },

      ...mapActions('Alerts', ['apiGetOpenedAlertByCourse']),
      ...mapMutations('Alerts', ['setAlerts']),
    },


    mounted() {
      if (process.env.VUE_APP_SENTRY_ENV == "production") {
        this.$analytics.setCurrentScreen("Web Alerts Overview");
        this.$analytics.logEvent("web_alerts_overview");
      }
    
      this.loadData();
    },

  };

</script>
